export const ITEMS = {
  en: {
    formalUniform: [
      "Boys Blazer",
      "Girls Blazer",
      "Boys Formal Shirt",
      "Girls Formal Shirt",
      "Peter Pan's Shirt",
      "Boys Trousers",
      "Girls Trousers",
      "Girls Skort",
      "Boys Jumper",
      "Girls Cardigan",
      "Tie",
    ],
    dailyUniform: [
      "Long Sleeve Polo",
      "Navy Summer Polo",
      "White Summer Polo",
      "Sweat Shirt",
      "Zip Hoodie",
      "Girls Winter Dress",
      "Girls Light Blue Summer Dress",
      "Girls Navy Summer Dress",
      "Boy's Shorts",
      "Windbreaker",
    ],
    peUniform: [
      "PE T-Shirt",
      "PE Cotton T-Shirt",
      "PE Shorts",
      "PE Cotton Shorts",
      "PE Skort",
      "PE Leggings",
      "PE Joggers",
      "PE Zip Sweat-Shirt",
      "PE Twill Bag",
      "Short Sleeve Rash-Guard",
    ],
    swimmingItems: [
      "Girls Swimsuit",
      "KC Leotard",
      "Boy's Jammers",
      "Boys Surf Shorts",
      "Lycra Swim Cap",
      "Terry Towel",
    ],
    housesItems: [
      "Eagle Yellow House T-Shirt",
      "Lynx Green House T-Shirt",
      "Shark Navy House T-Shirt",
      "Rhino Red House T-Shirt",
    ],
    winterItems: [
      "Lightweight Hooded Padded Jacket",
      "Lightweight Bodywarmer",
      "Polar Fleece Zip Jacket",
    ],
    accessoriesItems: [
      "Backpack KC",
      "Book Bag",
      "Bucket Hat",
      "Cap",
      "Knee High Socks",
      "PE Knee High Socks",
      "Anklet Socks",
      "Tights",
    ],
  },
  pt: {
    formalUniform: [
      "Blazer Menino",
      "Blazer Menina",
      "Camisa Formal Menino",
      "Camisa Formal Menina",
      "Camisa Peter Pan",
      "Calças Menino",
      "Calças Menina",
      "Saia-calção Menina",
      "Camisola Menino",
      "Casaco Malha Menina",
      "Gravata",
    ],
    dailyUniform: [
      "Polo Manga Comprida",
      "Polo Verão Azul",
      "Polo Verão Branco",
      "Sweatshirt",
      "Sweatshirt com Fecho",
      "Vestido Inverno Menina",
      "Vestido Verão Azul Claro Menina",
      "Vestido Verão Azul Menina",
      "Calções Menino",
      "Windbreaker",
    ],
    peUniform: [
      "T-shirt Desporto",
      "T-shirt Algodão Desporto",
      "Calções Desporto",
      "Calções Algodão Desporto",
      "Saia-calção Desporto",
      "Leggings Desporto",
      "Calças Desporto",
      "Sweatshirt Fecho Desporto",
      "Saco Desporto",
      "Rash-Guard Manga Curta",
    ],
    swimmingItems: [
      "Fato de Banho Menina",
      "Leotard KC",
      "Calções Natação Menino",
      "Calções Surf Menino",
      "Touca Lycra",
      "Toalha",
    ],
    housesItems: [
      "T-shirt Casa Eagle Amarela",
      "T-shirt Casa Lynx Verde",
      "T-shirt Casa Shark Azul",
      "T-shirt Casa Rhino Vermelha",
    ],
    winterItems: [
      "Casaco Acolchoado com Capuz",
      "Colete",
      "Casaco Polar com Fecho",
    ],
    accessoriesItems: [
      "Mochila KC",
      "Mala Livros",
      "Chapéu Balde",
      "Boné",
      "Meias Altas",
      "Meias Altas Desporto",
      "Meias Curtas",
      "Collants",
    ],
  }
};

export const SIZES = ["1Y", "2Y", "4Y", "6Y", "8Y", "10Y", "12Y", "14Y", "S", "M", "L", "XL", "2XL", "3XL"];

export const CATEGORIES = ["formal", "daily", "pe", "swimming", "houses", "winter", "accessories"];

export const ITEM_CATEGORY_MAP = {
  formalUniform: "formal",
  dailyUniform: "daily",
  peUniform: "pe",
  swimmingItems: "swimming",
  housesItems: "houses",
  winterItems: "winter",
  accessoriesItems: "accessories",
};
